import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as jsPDF from 'jspdf';
import { Estadistica, EstadisticaCanvas } from 'src/app/intranet/model/estadistica';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels';
import { IntranetService } from 'src/app/intranet/intranet.service';
import { AlertaService } from 'src/app/util/alerta.service';
import { ParametrosConst } from 'src/app/util/parametrosConst';

@Component({
  selector: 'sura-enviar-estadistica',
  templateUrl: './enviar-estadistica.component.html',
  styleUrls: ['./enviar-estadistica.component.scss']
})
export class EnviarEstadisticaComponent implements OnInit {
  arrayEstadistica: Estadistica[] = [];
  arrayChart: EstadisticaCanvas[] = [];

  constructor(public _intranetService: IntranetService,
    private alertaService: AlertaService,
    public dialogRef: MatDialogRef<EnviarEstadisticaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idAsamblea: number }) {
      Chart.defaults.global.defaultFontFamily = "'fs_sura_sans', normal";
  }

  ngOnInit() {
    this._intranetService.listarResultados(this.data.idAsamblea).then(respuesta => {
      if (respuesta instanceof Array) {
        for (let index = 0; index < respuesta.length; index++) {
          let estadistica: Estadistica = new Estadistica();
          estadistica = Object.assign(estadistica, respuesta[index]);
          this.arrayEstadistica.push(estadistica);
        }
        this.dibujarEstadistica();
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  enviarPDF() {
    const doc = new jsPDF('p', 'mm');
    const saltoLinea = 5;
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const w = pageWidth * 2 / 3;
    const margenX = 20;
    let margenY = 20;
    let heightLeft = pageHeight;
    doc.setFont('helvetica');
    doc.setFontType('bold');
    doc.setFontSize(20);
    doc.text(95, margenY, 'Resultados');
    margenY += saltoLinea * 3;
    for (let index = 0; index < this.arrayChart.length; index++) {
      const estadisticaCanvas = this.arrayChart[index];
      const h = estadisticaCanvas.chart.height * w / estadisticaCanvas.chart.width;
      if (index > 0) {
        if (heightLeft < h) {
          doc.addPage();
          heightLeft = pageHeight;
          margenY = 20;
        } else {
          margenY += saltoLinea;
        }
      }
      doc.setFont('helvetica');
      doc.setFontType('normal');
      doc.setFontSize(14);
      doc.text(margenX, margenY, '- Votación ' + (index + 1));
      margenY += saltoLinea;
      const imgData = estadisticaCanvas.chart.canvas.toDataURL('image/png');
      doc.addImage(imgData, 'JPEG', margenX / 1.5, margenY, w, h);
      // insertar totales
      doc.setFont('helvetica');
      doc.setFontType('normal');
      doc.setFontSize(10);
      doc.text(w + margenX / 1.5, margenY + 30, '# Total Miembros:   ' + estadisticaCanvas.estadistica.totalMiembros);
      doc.text(w + margenX / 1.5, margenY + 30 + saltoLinea, '# Total Asistentes: ' + estadisticaCanvas.estadistica.totalAsistentes);
      doc.text(w + margenX / 1.5, margenY + 30 + saltoLinea * 2, '# Total Votos:      ' + estadisticaCanvas.estadistica.totalVotos);

      margenY += h + saltoLinea;
      doc.line(50, margenY, 161, margenY); // horizontal line
      margenY += saltoLinea * 3;
      heightLeft -= margenY;
    }
    const nameFile = this.generarNombreFile();
    const blob = doc.output('blob', nameFile);
    const form = new FormData();     // To carry on your data
    const file = new File([blob], nameFile, {
      type: blob.type // optional - default = ''
    });
    form.append('file', file);
    this.subirArchivo(form);
    // doc.save(nameFile);
  }

  subirArchivo(form: FormData) {
    this._intranetService.subirArchivo(form).then((respuesta: any) => {
      this.enviarCorreo(respuesta.fileName);
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  enviarCorreo(fileName: string) {
    this._intranetService.enviarCorreoAdjunto(this.data.idAsamblea, fileName).then(respuesta => {
      this.alertaService.success(respuesta);
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  generarNombreFile(): string {
    const f = new Date();
    return 'reporte-resultados-' + f.getTime() + '' + '.pdf';
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  buscarEstadistica() {
  }

  dibujarEstadistica() {
    const contentPDF = document.getElementById('contentPDF');
    for (let index = 0; index < this.arrayEstadistica.length; index++) {
      const objectEstadistica = this.arrayEstadistica[index];
      const dataset = this.getDataSet(objectEstadistica);

      const estadistica = this.getDataEstadistica(this.arrayEstadistica[index]);
      const config = {
        type: objectEstadistica.tipoPregunta === ParametrosConst.PREGUNTA_SIMPLE ? 'doughnut' : 'bar',
        data: {
          datasets: dataset,
          labels: objectEstadistica.tipoPregunta === ParametrosConst.PREGUNTA_SIMPLE ?  estadistica.arrayLabel : ['']
        },
        plugins: [ChartDataLabels],
        options: {
          legend: {
            display: true
          },
          scales: objectEstadistica.tipoPregunta === ParametrosConst.PREGUNTA_MULTIPLE ? {
            yAxes: [{
              ticks: {
                reverse: false,
                beginAtZero: true,
                suggestedMin: 0,
                suggestedMax: 100
              }
            }]
          } : {},
          responsive: true,
          tooltips: {
            enabled: true,
            callbacks: {
              label(tooltipItem, data) {
                if (data.labels.length === 1 && data.labels[0] === '') {
                 return data.datasets[tooltipItem.datasetIndex].label;
                }
                return data.labels[tooltipItem.index];
              }
            },
            // intersect : false,
          },
          plugins: {
            datalabels: {
              backgroundColor(context) {
                return context.dataset.backgroundColor;
              },
              borderColor: 'white',
              borderRadius: 25,
              borderWidth: 1,
              color: 'white',
              display(context) {
                // const dataset = context.dataset;
                // const count = dataset.data.length;
                // const value = dataset.data[context.dataIndex];
                return !estadistica.indResultadoVacia;
              },
              formatter(value, context) {
                return value + '%';
              },
              font: {
                weight: 'bold'
              }
            }
          }
        },
      };
      const htmlTotales = '<div class="row justify-content-sm-center"> <div class="col-sm-12 text-center mb-1"> <strong style="width: 150px;display: inline-block;text-align: left;"># Total Miembros:</strong> ' + objectEstadistica.totalMiembros + '</div>  <div class="col-sm-12 text-center mb-1"> <strong style="width: 150px;display: inline-block;text-align: left;"># Total Asistentes:</strong><span > ' + objectEstadistica.totalAsistentes + '</span> </div> <div class="col-sm-12 text-center "> <strong style="width: 150px;display: inline-block;text-align: left;"># Total Votos:</strong><span > ' + objectEstadistica.totalVotos + '</span> </div> </div>';
      const divContent = document.createElement('div');
      divContent.setAttribute('class', 'row');
      divContent.setAttribute('id', 'contentChart-' + index);
      const p = document.createElement('h4');
      p.setAttribute('class', 'col-12');
      const newContent = document.createTextNode('Votación ' + (index + 1) + ':');
      p.appendChild(newContent);
      divContent.appendChild(p);
      divContent.appendChild(document.createElement('hr'));

      const divColCanvas = document.createElement('div');
      divColCanvas.setAttribute('class', 'col-12 col-md-8');
      const canvas = document.createElement('canvas');
      divColCanvas.appendChild(canvas);

      const divColTotales = document.createElement('div');
      divColTotales.setAttribute('class', 'col-12 col-md-4 text-center mt-0 mt-sm-5');
      divColTotales.innerHTML = htmlTotales;

      const myChart = new Chart(canvas, config);
      // añade el elemento creado y su contenido al DOM
      divContent.appendChild(divColCanvas);
      divContent.appendChild(divColTotales);
      contentPDF.appendChild(divContent);
      const estadisticaCanvas = new EstadisticaCanvas();
      estadisticaCanvas.estadistica = objectEstadistica;
      estadisticaCanvas.chart = myChart;
      this.arrayChart.push(estadisticaCanvas);
    }
    // document.body.insertBefore(divContent, contentPDF);
    // myLineChart.destroy();
  }

  getDataSet(estadistica: Estadistica) {
    let dataset = [];
    const data = this.getDataEstadistica(estadistica)['arrayData'];
    const bg = this.getDataEstadistica(estadistica)['arrayBackgroundColor'];
    const label = this.getDataEstadistica(estadistica)['arrayLabel'];

    if (estadistica.tipoPregunta === ParametrosConst.PREGUNTA_MULTIPLE ) {
      for (let i = 0; i < data.length; i++) {
        dataset.push({
          label: label[i],
          backgroundColor: bg[i],
          /*hoverBorderColor: "rgba(255,99,132,1)",*/
          data: [data[i]],
       });
      }
    } else {
      dataset = [{
        data: data,
        backgroundColor: bg,
        datalabels: {
          anchor: 'center'
        }
      }];
    }

    return dataset;
  }

  getDataEstadistica(estadistica: Estadistica) {
    const arrayData = [];
    const arrayLabel = [];
    let arrayBackgroundColor = [];
    let enabledTooltips = false;
    let indResultadoVacia = false;
    if (estadistica.totalVotos === 0) {
      indResultadoVacia = true;
      arrayData.push('1');
      arrayLabel.push('Sin Voto');
      arrayBackgroundColor.push('rgb(126,	128	,131)');
      enabledTooltips = false;
    } else {
      indResultadoVacia = false;
      enabledTooltips = false;
      arrayBackgroundColor = [
        'rgb(30,	46,	110)', 'rgb(0,	174,	203)', 'rgb(227,	232,	41)', 'rgb(220,	221,	222)', 'rgb(183,	176, 156)', 'rgb(154, 185, 173)', 'rgb(205, 167, 136)', 'rgb(156, 162, 162)', 'rgb(163, 147, 130)'
      ];
      for (let index = 0; index < estadistica.porcentajes.length; index++) {
        arrayData.push(estadistica.porcentajes[index].porcentaje);
        arrayLabel.push(
          estadistica.porcentajes[index].voto +
          (estadistica.tipoPregunta === ParametrosConst.PREGUNTA_MULTIPLE ? ' : ' : '(' + estadistica.porcentajes[index].cantidad + ' votos) : ') +
          estadistica.porcentajes[index].porcentaje + '%');
      }
    }
    return {
      arrayData,
      arrayLabel,
      arrayBackgroundColor,
      enabledTooltips,
      indResultadoVacia
    };
  }
}
